import { getStyle, hexToRgba } from '@coreui/utils';
import { useEffect, useState } from 'react';
import Logger from '../../../utils/Logger';
import React from 'react';
import axios from 'axios';
const brandPrimary = getStyle('--primary');
const brandSuccess = getStyle('--success');
const brandInfo = getStyle('--info');
const brandWarning = getStyle('--warning');
const brandDanger = getStyle('--danger');

export const useChartData = () => {
  const [cr_data, setCRData] = useState({
    labels: [],
    datasets: [],
  });

  useEffect(() => {
    const labels = [];
    const dataPoints0 = [];
    const dataPoints1 = [];
    const totalDays = getTotalDaysInCurrentMonth();

    for (let i = 0; i < totalDays; i++) {
      labels.push(`${i + 1}`);
      dataPoints0.push({ x: i, value: Math.floor(Math.random() * 150) + 50, isEvent: false });
      dataPoints1.push({ x: i, value: Math.floor(Math.random() * 200) + 80, isEvent: false });
    }

    setCRData({
      labels,
      datasets: [
        {
          label: 'Steps',
          backgroundColor: hexToRgba(getStyle('--cui-info'), 10),
          borderColor: getStyle('--cui-info'),
          data: dataPoints0,
        },
        {
          label: 'Calories',
          backgroundColor: hexToRgba(getStyle('--cui-warning'), 10),
          borderColor: getStyle('--cui-warning'),
          data: dataPoints1,
        },
      ],
    });
  }, [setCRData]);

  return { cr_data, setCRData };
};

// Move helper functions to the top, before any hooks or component logic
export const getFirstAndLastDayOfMonth = () => {
  const now = new Date();
  const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
  const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  // Set last day to 11:59:59 PM
  lastDay.setHours(23, 59, 59, 999);
  // console.log('firstDay', firstDay);
  // console.log('lastDay', lastDay);
  // console.log(firstDay.toISOString());
  // console.log(lastDay.toISOString());
  return { firstDay, lastDay };
};

export const getTotalDaysInMonth = (year, month) => {
  return new Date(year, month + 1, 0).getDate();
};


export const showAlert = () => {
  setTimeout(() => { }, 3000);
};

export const getRandomColor = () => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

export const fetchDebitsFromFHIR = async (firstDay, lastDay) => {
  try {
    const fhirEndpoint = 'https://fhir.mieros.cloud/fhir';
    const mieFToken = localStorage.getItem('mieFToken');

    if (!mieFToken) {
      console.error('No authentication token found.');
      return [];
    }

    // Get authUser from context or localStorage fallback
    const authUser = JSON.parse(localStorage.getItem('authUser')) || {};
    const queryUrl = `${fhirEndpoint}/ChargeItem?entered-date=ge${firstDay.toISOString()}&entered-date=le${lastDay.toISOString()}&identifier=https://fhir.mieros.cloud/fhir/ids|${authUser.uid || 'default'}`;

    const response = await axios.get(queryUrl, {
      headers: {
        'Content-Type': 'application/fhir+json',
        Authorization: `Bearer ${mieFToken}`,
      },
    });

    const chargeItems = response.data.entry || [];
    const debits = chargeItems.map((entry) => {
      const item = entry.resource;
      return {
        date: item.enteredDate || item.servicedDate?.start,
        amount: item.quantity.value,
      };
    });

    return debits;
  } catch (error) {
    console.error('Error fetching debits from FHIR:', error);
    return [];
  }
};


export const getTotalDaysInCurrentMonth = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // getMonth() returns 0-based month index
  return new Date(year, month, 0).getDate(); // 0 means the last day of the previous month
};
export const mainChartOpts = {
  tooltips: {
    enabled: true,
    intersect: true,
    mode: 'index',
    position: 'nearest',
    callbacks: {
      labelColor: function (tooltipItem, chart) {
        return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor };
      }
    }
  },
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    }
  },
  scales: {
    x: {
      grid: {
        drawOnChartArea: false,
        color: 'rgba(255, 255, 255, 0.08)',
      },
      ticks: { color: '#94A3B8' },
    },
    y: {
      grid: { color: 'rgba(255, 255, 255, 0.08)' },
      ticks: {
        beginAtZero: true,
        maxTicksLimit: 5,
        stepSize: Math.ceil(250 / 5),
        max: 250,
        color: '#94A3B8',
      },
    },
  },
  elements: {
    line: {
      tension: 0.4,
      borderWidth: 2,
    },
    point: {
      radius: 4,
      hitRadius: 10,
      hoverRadius: 6,
    }
  },
};